
    import './styles.scoped.css';
    export default {
  "dismiss-button": "awsui_dismiss-button_dm8gx_v15c2_9",
  "token": "awsui_token_dm8gx_v15c2_10",
  "root": "awsui_root_dm8gx_v15c2_14",
  "has-items": "awsui_has-items_dm8gx_v15c2_45",
  "no-padding": "awsui_no-padding_dm8gx_v15c2_45"
};
  